export function roundNumber(floatNumber: number) {
	return Math.round(floatNumber * 100) / 100;
}
